export default {
    get apiUrl() {
        return `${process.env.VUE_APP_BACK}`;
    },
    get baseUrl() {
        return process.env.VUE_APP_BACK;
    },
    get apiDashboardUrl() {
        return `${process.env.VUE_APP_DASHBOARD}`;
    },

    get apiUsersUrl() {
        return `${process.env.VUE_APP_USERS}`;
    },

    get analyticsId() {
        return `${process.env.VUE_APP_GA_ID}`;
    },
};
